import { render, staticRenderFns } from "./PostMortem.vue?vue&type=template&id=f113426c&scoped=true&"
import script from "./PostMortem.vue?vue&type=script&lang=js&"
export * from "./PostMortem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f113426c",
  null
  
)

export default component.exports